module.exports = __webpack_public_path__ + "static/img/1.c89fafc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/miImgs/1.jpg
// module id = W84x
// module chunks = 20